/**
 * Short generic CTAs ("Learn more", "Shop now"): set aria-label to "{phrase}: {context}" when context can be inferred.
 * Skips data-skip-cta-a11y, or when aria-label already looks descriptive.
 */
(function () {
  function norm(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
  }

  var SHORT_CTAS = [
    { match: /^learn more\.?$/i, enriched: /^learn more\s*:/i, prefix: 'Learn more: ' },
    { match: /^shop now\.?$/i, enriched: /^shop now\s*:/i, prefix: 'Shop now: ' },
  ];

  function contextFor(el) {
    var d = el.getAttribute('data-cta-context');
    if (d && norm(d)) return norm(d);
    var wrap = el.closest('[data-cta-context]');
    if (wrap && wrap !== el) {
      var v = wrap.getAttribute('data-cta-context');
      if (v && norm(v)) return norm(v);
    }
    var cur = el.parentElement;
    for (var depth = 0; cur && cur !== document.body && depth < 14; depth++, cur = cur.parentElement) {
      var h = cur.querySelector(
        ':scope > h1, :scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6'
      );
      if (h) return norm(h.textContent);
      var prev = cur.previousElementSibling;
      while (prev) {
        if (/^H[1-6]$/i.test(prev.tagName)) return norm(prev.textContent);
        var inner = prev.querySelector('h1, h2, h3, h4, h5, h6');
        if (inner) return norm(inner.textContent);
        prev = prev.previousElementSibling;
      }
    }
    return '';
  }

  function enhance() {
    var sel = 'a[href], button[type="button"], button:not([type]), button[type="submit"]';
    var nodes = document.querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute('data-skip-cta-a11y')) continue;
      var text = norm(el.textContent);
      var existing = norm(el.getAttribute('aria-label') || '');
      var cta = null;
      for (var j = 0; j < SHORT_CTAS.length; j++) {
        if (SHORT_CTAS[j].match.test(text)) {
          cta = SHORT_CTAS[j];
          break;
        }
      }
      if (!cta) continue;
      if (existing) {
        if (cta.enriched.test(existing)) continue;
        if (!cta.match.test(existing)) continue;
      }
      var ctx = contextFor(el);
      if (!ctx) continue;
      el.setAttribute('aria-label', cta.prefix + ctx);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
})();
